import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Importing pages
const CreateStudent = lazy(() =>
  import("./features/students/components/CreateStudent")
);
const ViewStudent = lazy(() =>
  import("./features/students/components/ViewStudent")
);

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));
const CreateListeningTest = lazy(() =>
  import("./features/listeingTest/components/CreateListeningTest")
);

const ViewEmployee = lazy(() =>
  import("./features/employeeAcounts/components/ViewEmployee")
);
// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();

function App() {
  useEffect(() => {
    // App initialization
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          />

          <Route
            path="*"
            element={
              <Navigate to={token ? "/app/welcome" : "/login"} replace />
            }
          />
          {/* <Route path="/app/employee/view/:id" element={<ViewEmployee />} /> */}
        </Routes>
      </Router>
    </>
  );
}

export default App;
